import { render, staticRenderFns } from "./PassengerFlowYear.vue?vue&type=template&id=51d9fee7&scoped=true&"
import script from "./PassengerFlowYear.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowYear.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowYear.vue?vue&type=style&index=0&id=51d9fee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9fee7",
  null
  
)

export default component.exports